/**
 * !!! Shouldn't be used directly. Is used by integrationAPI.
 */
import co from 'co'
import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'
import has from 'lodash/has'
import find from 'lodash/find'
import set from 'lodash/set'
import unset from 'lodash/unset'
import get from 'lodash/get'
import keys from 'lodash/keys'
import split from 'lodash/split'

import renderHTML from 'react-render-html'
import * as integrationType from 'constants/integrationType'
import { DYNAMIC_URL } from 'constants'
import { setIntegrationProducts } from 'actions/integrationProductsAC'
import { getProductFromDict } from './productsDict'
import ShopifyFetchApi from './shopifyFetchApi'

class shopifyAPI {

  constructor (appId, shopName, onInitialized, dispatch, productIds = []) {
    this.cart = null
    this.onInitialized = onInitialized
    this.appId = appId
    this.optionsMaps = {}
    this.shopName = shopName
    this.products = []
    this.cart = {}
    this.dispatch = dispatch
    this.productIds = productIds

    this.makeCart = this.makeCart.bind(this)
    this.fetchAllProducts = this.fetchAllProducts.bind(this)
    this._init = this._init.bind(this)
    this.addVariantToCart = this.addVariantToCart.bind(this)
    this.fetchApi = new ShopifyFetchApi()
  }

  checkParams = (appId, shopName) => appId === this.appId && shopName === this.shopName

  updateDispatch (dispatch) {
    this.dispatch = dispatch
    console.log('re-dispatch availableProducts', this.availableProductsList)
    this.dispatch(setIntegrationProducts(this.availableProductsList))
  }

  type () {
    return integrationType.SHOPIFY
  }

  _saveCart () {
    window.localStorage.setItem(`${this.appId}cart`, JSON.stringify(this.cart))
  }

  availableProducts () {
    return this.products
  }

  * makeCart () {
    console.log('make cart')
    try {
      const localCart = JSON.parse(window.localStorage.getItem(`${this.appId}cart`))
      console.log('localCart', localCart)
      /*TODO: finish
      const shopifyCart = yield this.fetchApi.getCart()
      console.log('shopifyCart', shopifyCart)
      const tempCart = {}
      // synchronize local cart from shopify
      if (shopifyCart && shopifyCart.items) {
        for (const item of shopifyCart.items) {
          tempCart[item.id] = { productId: item.product_id, options: item.variant_options, ...item }
        }
      }
      console.log('updated', tempCart)*/
      // console.log('lastCartId', lastCartId)
      if (localCart) {
        try {
          // console.log('cart already exists', remoteCart)
          this.cart = localCart
        } catch (e) {
          console.log('fetchCart error', e)
        }
      }
    } catch (e) {
      console.log('loading cart error', e)
      window.localStorage.removeItem(`${this.appId}cart`)
    }
  }

  * fetchAllProducts () {
    try {
      const url = `${DYNAMIC_URL}/proto?actionType=shopify_get_all_products`
      // console.log('url', url)
      const body = {
        shopName: this.shopName,
        productIds: this.productIds
      }
      const response = yield fetch(url, {
        method: 'post',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }
      )
      const resJson = yield response.json()
      console.log('products response', resJson)
      if (resJson.products) {
        this.products = resJson.products
        console.log('fetched products', this.products)
        this.availableProductsList = this.products.map(p => this.getProductInfo({productId: p.id}, {}))
        console.log('availableProductsList', this.availableProductsList)
        console.log('dispatch setIntegrationProducts count', this.availableProductsList.length)
        this.dispatch(setIntegrationProducts(this.availableProductsList))
        return true
      } else {
        return false
      }
    } catch (e) {
      console.log('fetchAllProducts error', e)
      return false
    }
    // console.log('products', this.products)
  }

  * _init () {
    if (this.shopName) {
      yield this.makeCart()
      const successed = yield this.fetchAllProducts()
      // console.log('api initialized')
      this.initialized = successed
      this.onInitialized(true)
    } else {
      this.initialized = false
      this.onInitialized(true)
    }
  }

  refreshProducts () {
    co(this.fetchAllProducts())
  }

  init () {
    co(this._init())
  }

  cancel () {
    this.onInitialized = () => null
  }

  _productById (id) {
    if (this.products) {
      return this.products.find(product => product.id === id)
    } else {
      return null
    }
  }

  _productExists (id) {
    if (this.products) {
      const p = this.products.find(product => product.id === id)
      return (isNil(p))
    } else {
      return false
    }
  }

  _variantByProductIdOptions (productId, options) {
    const p = this._productById(productId)
    // console.log('_variantByProductIdOptions', p, 'options', options)
    if (p) {
      if (!options || isEmpty(options)) {
        // console.log('---->', +p.selectedVariant.price)
        return null
      } else {
        // console.log('getProductPrice', p, sOptions)
        let variant
        for (const v of p.variants) {
          let valid = true
          if (v.option1) valid = valid && options[p.options[0].name] === v.option1
          if (v.option2) valid = valid && options[p.options[1].name] === v.option2
          if (v.option3) valid = valid && options[p.options[2].name] === v.option3
          // if (v.option2) acc.push(`${p.options[1].name}_${v.option2}`)
          // if (v.option3) acc.push(`${p.options[2].name}_${v.option3}`)
          // for (const o of v.optionValues) {
          //   valid = valid && o.value === options[o.name]
          // }
          if (valid) variant = v
        }
        if (variant) {
          return variant
        } else {
          return null
        }
      }
    } else {
      return null
    }
  }

  getProductPrice (product, options) {
    // console.log('getProductPrice', product, options)
    const p = this._variantByProductIdOptions(product.productId, options)
    return p ? +p.price : null
  }

  getProductPrevPrice (product, options) {
    // console.log('getPrevProductPrice', product, options)
    const p = this._variantByProductIdOptions(product.productId, options)
    return p ? +p.compare_at_price : null
  }

  _renderProductDescription (body) {
    try {
      if (isNil(body)) return ''
      return renderHTML(body)
    } catch (e) {
      console.warn('Can`t render description', body, 'error', e)
    }
  }

  getProductInfo (p, productsDict = {}) {
    try {
      if (has(p, 'productId')) {

        const shopifyProduct = this._productById(p.productId)
        // if (p.productId === 8397942027) {
        //   console.log('getProductInfo', p)
        //   console.log('shopifyProduct', shopifyProduct)
        // }
        if (shopifyProduct) {
          const product = {...p}
          const variants = []
          for (const option of shopifyProduct.options) {
            // console.log('process option', option)
            const opt = {
              id: option.name,
              title: option.name,
              options: []
            }
            for (const v of option.values) {
              opt.options.push({
                id: v,
                title: v
              })
            }
            variants.push(opt)
          }
          // console.log('created variants', variants)
          const defaultOptions = {}
          const v = shopifyProduct.variants[0]
          if (v.option1) defaultOptions[shopifyProduct.options[0].name] = v.option1
          if (v.option2) defaultOptions[shopifyProduct.options[1].name] = v.option2
          if (v.option3) defaultOptions[shopifyProduct.options[2].name] = v.option3
          const res = {
            ...product,
            title: shopifyProduct.title,
            productLink: `https://${this.shopName}.shopify.com/product/${p.productId}`,
            details: {
              available: (has(shopifyProduct, ['attrs', 'available'])) ? shopifyProduct.attrs.available : true,
              title: shopifyProduct.title,
              description: this._renderProductDescription(shopifyProduct.body_html),
              pureDescription: shopifyProduct.body_html, // needed for Instagram WebView to render correctly
              price: +shopifyProduct.variants[0].price,
              images: shopifyProduct.images.map(imageObj => imageObj.src),
              options: shopifyProduct.options,
              defaultOptions: defaultOptions,
              storeIcon: integrationType.SHOPIFY,
              prevPrice: +shopifyProduct.variants[0].compare_at_price
            }
          }
          // console.log('return product', res)
          return res
        } else {
          // console.log('searchig in productsDict', p)
          const res = getProductFromDict(p, productsDict)
          if (res) return res
        }
      }
      // console.log('shopify product is not exist', p)
      const newP = {...p}
      set(newP, ['details', 'available'], false)
      return newP
    } catch (e) {
      console.log('getProductInfo error', e)
      const newP = {...p}
      set(newP, ['details', 'available'], false)
      return newP
    }
  }

  addVariantToCart (p, variant, quantity) {
    // console.log('CART: addVariantToCart product', p, 'variant', variant, 'quantity', quantity)
    try {
      if (!has(this.cart, variant.id)) {
        const options = []
        if (variant.option1) options.push({title: p.options[0].name, value: variant.option1})
        if (variant.option2) options.push({title: p.options[1].name, value: variant.option2})
        if (variant.option3) options.push({title: p.options[2].name, value: variant.option3})
        this.cart[variant.id] = {
          productId: variant.product_id,
          quantity: quantity,
          title: p.title,
          price: variant.price,
          image: p.image.src,
          options
        }
      } else {
        this.cart[variant.id].quantity = this.cart[variant.id].quantity + quantity
      }
      this._saveCart()
      this._cartChanged()
      // console.log('CART: variant added, cart', this.cart)
      this.fetchApi.updateCart(variant.id, this.cart[variant.id].quantity)
    } catch (e) {
      console.log('CART: addVariantToCart error:', e)
    }
  }

  addToCart (product, options) {
    console.log('CART: ---> add to cart item', product, options)
    const variant = this._variantByProductIdOptions(product.productId, options)
    const p = this._productById(product.productId)
    if (variant) {
      this.addVariantToCart(p, variant, 1)
    } else {
      console.log('CART: variant not found')
    }
  }

  _cartChanged () {
    if (!isNil(this.onChangeCart)) {
      const c = this.getCart()
      // console.log('on change cart', c)
      this.onChangeCart(c)
    }
  }

  _variantByProductIdVariantId (productId, variantId) {
    const product = this._productById(productId)
    // console.log('_variantByProductIdVariantId', productId, variantId, product)
    if (product && !isNil(product.variants)) {
      return find(product.variants, v => v.id === Number(variantId))
    } else {
      return null
    }
  }

  getCart () {
    const c = {
      subtotal: 0,
      checkoutUrl: '',
      products: []
    }

    for (const variantId in this.cart) {
      const lineItem = this.cart[variantId]
      const p = {
        id: variantId,
        title: lineItem.title,
        price: lineItem.price,
        image: lineItem.image,
        variant: lineItem.options
      }
      c.subtotal = c.subtotal + Number(lineItem.price) * lineItem.quantity
      if (c.checkoutUrl === '') {
        c.checkoutUrl = `https://${this.shopName}.myshopify.com/cart/${variantId}:${lineItem.quantity}`
      } else {
        c.checkoutUrl = `${c.checkoutUrl},${variantId}:${lineItem.quantity}`
      }

      for (let i = 0; i < lineItem.quantity; i++) {
        c.products.push({...p})
      }
    }
    return c
  }

  setOnChangeCart (callback) {
    this.onChangeCart = callback
  }

  deleteFromCart (variantId) {
    if (has(this.cart, variantId)) {
      const v = this.cart[variantId]
      v.quantity = Math.max(0, v.quantity - 1)
      if (v.quantity === 0) {
        unset(this.cart, variantId)
      }
      this._saveCart()
      this._cartChanged()
      console.log('updateCart', variantId, v.quantity)
      this.fetchApi.updateCart(variantId, v.quantity)
    } else {
      console.log('cart has no such variant', variantId)
    }
  }

  _optionsMapByProductId (productId) {
    if (!productId) {
      return null
    } else if (has(this.optionsMaps, productId)) {
      return this.optionsMaps[productId]
    } else {
      const p = this._productById(productId)
      if (!p) return null
      const optionsMap = {}
      // console.log('_optionsMapByProductId', p)
      for (const v of p.variants) {
        let acc = []
        if (v.option1) acc.push(`${p.options[0].name}_${v.option1}`)
        if (v.option2) acc.push(`${p.options[1].name}_${v.option2}`)
        if (v.option3) acc.push(`${p.options[2].name}_${v.option3}`)
        // for (const o of v.optionValues) {
        //   acc.push(`${o.name}_${o.value}`)
        // }
        set(optionsMap, acc, true)
      }
      // console.log('optionsMap', optionsMap)
      this.optionsMaps[productId] = optionsMap
      return optionsMap
    }
  }

  getDisabledOptions (product, selectedOptions) {
    // return product.details.options
    if (isNil(selectedOptions) || !has(product, 'productId') || !this._productExists(product.productId)) {
      return {}
    } else {
      const optionsMap = this._optionsMapByProductId(product.productId)
      if (optionsMap) {
        // console.log('optionsMap', optionsMap)
        const res = {}
        const curSelectedPath = []
        const options = {...product.details.options}
        for (const option of options) {
          let addToPathValue
          for (const v of option.values) {
            const eltId = `${option.name}_${v}`
            if (selectedOptions[option.name] === v) addToPathValue = eltId
            const newCurSelectedPath = {...curSelectedPath}
            newCurSelectedPath.push(eltId)
            // console.log('has: ', newCurSelectedPath, has(optionsMap, newCurSelectedPath))
            if (!has(optionsMap, newCurSelectedPath)) {
              if (!res[option.name]) res[option.name] = []
              res[option.name].push(v)
            }
          }
          if (addToPathValue) curSelectedPath.push(addToPathValue)
        }
        return res
      } else {
        return {}
      }
    }
  }

  getAvailableOptions (product, options) {
    // console.log('product', product, 'options', options)
    const optionsMap = this._optionsMapByProductId(product.productId)
    if (optionsMap) {
      const path = []
      const res = {}
      for (const name in options) {
        const value = options[name]
        const eltId = `${name}_${value}`
        const newPath = [...path]
        newPath.push(eltId)
        if (has(optionsMap, newPath)) {
          path.push(eltId)
          res[name] = value
        } else {
          const available = get(optionsMap, path)
          const eltId = keys(available)[0]
          const nameValue = split(eltId, '_')
          const name = nameValue[0]
          const value = nameValue[1]
          path.push(eltId)
          res[name] = value
        }
      }
      return res
    } else {
      return options
    }
  }

  clearCart () {
    this.cart = {}
    this._saveCart()
    this.deleteCartHistory()
    this._cartChanged()
    this.fetchApi.clearCart()
  }

  deleteCartHistory () {
    window.localStorage.removeItem(`${this.appId}cart`)
  }

  isInitialized () {
    return this.initialized
  }

}

export default shopifyAPI



// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js